import React from "react";
import { Stack } from "@mui/material";
import { StyledThreeStackCard } from "./index.styles";

const ThreeStackCard = ({ topComponent, midComponent, botComponent, cssProps, handleClick = null, id = null, ...props }) => {
  const { layoutId } = props;

  return (
    <StyledThreeStackCard layoutId={layoutId} id={id} cssProps={cssProps} onClick={handleClick} {...props}>
      <Stack direction="column" sx={props.stackProps}>
        {topComponent}
        {midComponent}
        {botComponent}
      </Stack>
    </StyledThreeStackCard>
  );
};

export default ThreeStackCard;
